module.exports = __webpack_public_path__ + "static/media/workingmemory-numbers-9.3087c55a.mp3";